import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCGkhzktS1MwdIASAPoLabZqBXhsL02sck",
  authDomain: "waka-db96e.firebaseapp.com",
  projectId: "waka-db96e",
  storageBucket: "waka-db96e.firebasestorage.app",
  messagingSenderId: "500735237704",
  appId: "1:500735237704:web:79eee74dea18d3f4f5427d",
  measurementId: "G-E14LGG0CZ0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app); 
